import styled from "styled-components";
import { Container, Section, Eyebrow } from "./ui";
import Reveal from "./Reveal";

const steps = [
  {
    n: "1",
    t: "Hiqe kapakun",
    d: "Mbaje inhalatorin rreth një centimetër nga hunda. Nuk prek lëkurën dhe nuk lë asnjë gjurmë.",
  },
  {
    n: "2",
    t: "Merr dy ose tre frymëmarrje",
    d: "Ngadalë dhe thellë, nga secila vrimë e hundës. Frymëmarrja e ngadaltë është pjesë e rëndësishme e efektit.",
  },
  {
    n: "3",
    t: "Mbylle dhe vazhdo",
    d: "Kthe kapakun dhe fute në xhep. Mund ta përsëritësh sa herë të duash gjatë ditës.",
  },
];

export default function HowItWorks() {
  return (
    <Section>
      <Container>
        <Layout>
          <Left>
            <Reveal>
              <Eyebrow>Si përdoret</Eyebrow>
              <H2>Tri hapa, dhjetë sekonda</H2>
              <P>
                Aromaterapia nuk është e komplikuar. E gjithë ideja është një
                ritual i shkurtër që e përsërit çdo ditë, derisa trupi e lidh
                aromën me atë që po bën.
              </P>
            </Reveal>
          </Left>

          <Right>
            {steps.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.1}>
                <Step>
                  <Badge>{s.n}</Badge>
                  <div>
                    <StepTitle>{s.t}</StepTitle>
                    <StepText>{s.d}</StepText>
                  </div>
                </Step>
              </Reveal>
            ))}
          </Right>
        </Layout>
      </Container>
    </Section>
  );
}

const Layout = styled.div`
  display: grid;
  gap: 48px;
  grid-template-columns: 1fr;

  ${({ theme }) => theme.bp.md} {
    grid-template-columns: 0.85fr 1.15fr;
    gap: 80px;
  }
`;

const Left = styled.div``;

const H2 = styled.h2`
  font-size: ${({ theme }) => theme.size.h2};
  margin-bottom: 20px;
`;

const P = styled.p`
  color: ${({ theme }) => theme.colors.inkSoft};
  max-width: 40ch;
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Step = styled.div`
  display: flex;
  gap: 22px;
  padding: 28px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.line};

  ${({ theme }) => theme.bp.md} {
    gap: 32px;
    padding: 34px 0;
  }
`;

const Badge = styled.span`
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: ${({ theme }) => theme.colors.brandSoft};
  color: ${({ theme }) => theme.colors.brandDeep};
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.size.lg};
`;

const StepTitle = styled.h3`
  font-size: ${({ theme }) => theme.size.xl};
  margin-bottom: 9px;
`;

const StepText = styled.p`
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: ${({ theme }) => theme.size.sm};
  max-width: 48ch;
`;
